<div class="text-18 text-bold padding-bottom-24" dcrHTMLKey="ESG_UPLIFT_HEADER">ESG UPLIFT</div>

<div class="dz-flex padding-bottom-24">
	<dz-pictogram name="target" size="10"></dz-pictogram>
	<span class="text-bold padding-left-8" dcrHTMLKey="ESG_UPLIFT_SUBTEXT">Higher ESG ratings relative to a non-ESG optimized benchmark</span>
</div>

<bfa-chart [attr.data-cy]="'esg uplift chart'" [data]="data" [type]="chartType" [name]="chartName" [customAttributes]="customChartAttributes"></bfa-chart>

<div class="legend dz-flex">
	<div *ngFor="let model of modelNameList; let index = index">
		<div>
			<dz-icon class="margin-right-8 text-12" type="square-full" [ngStyle]="{ color: modelLegendColors[index] }"></dz-icon><span class="text-11">{{ model }}</span>
		</div>
		<div>
			<dz-icon class="margin-right-8 text-12" type="square-full" [ngStyle]="{ color: modelBenchmarkLegendColors[index] }"></dz-icon
			><span class="text-11">{{ model }} <span dcrHTMLKey="LEGEND_BENCHMARK_SUFFIX">Benchmark</span></span>
		</div>
	</div>
</div>
